exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".league-assistant[data-v-46951806] .ant-tree-treenode-selected .ant-tree-switcher-icon {\n  color: #1783e8 !important;\n}\n.league-assistant[data-v-46951806] .ant-tree-node-selected {\n  color: #1783e8 !important;\n}\n.league-assistant[data-v-46951806] .ant-tree-node-selected::before {\n  background: #eaf5ff !important;\n}\n", ""]);

// exports
